module.exports = __webpack_public_path__ + "img/china.287e31a2.svg";